const noop = () => undefined;

module.exports = process.env.REACT_APP_ENV === "v2" || process.env.REACT_APP_ENV === "v3" ? Object.fromEntries(Object.keys(console).map(key => [key, noop])) : console;